import React, { useEffect } from "react";
import styles from "./Header.module.css";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BiSolidUser } from "react-icons/bi";
import Logo from "../../assets/svgs/tevhidlogo.svg";

const Header = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (!userInfo) {
      navigate("/login");
    }
  }, [navigate, userInfo]);

  return (
    <div className={styles.container}>
      <img src={Logo} alt="tevhid" style={{ width: "100px" }} />
      <div className={styles.profilePart}>
        <h1>{userInfo?.name}</h1>
        <button onClick={() => navigate("/profile")} className={styles.userBtn}>
          <BiSolidUser size={20} />
        </button>
      </div>
    </div>
  );
};

export default Header;
